<template>
  <div class="goods-tag-container" id="print-goods-tag-one">
    <div class="goods-tag-item">
      <div class="goods-tag-left">
        <div class="out-no">出库单号：{{ goodsObj.outNo }}</div>
        <div class="other">出库类型：{{ goodsObj.outType | getLabelByCodeFilter("OUT_TYPE") }}</div>
        <div class="other">总销售量：{{ goodsObj.outSumNumber }}</div>
        <div class="other">总销售价：{{ goodsObj.outSumSalesPrice }}元</div>
        <div class="other">爆米花小布 嘉懿云仓</div>
      </div>
      <div class="goods-tag-right">
        <img class="qr-code" :src="goodsObj.qrCodeBase64" alt="商品二维码">
      </div>
    </div>
  </div>
</template>
<script>
import QRCode from "qrcode"
import printJS from "print-js"
// renderAs 默认是canvas 此时打印 二维码无法显示  改为 svg后可显示  此方式 会卡顿  需改成 生成图片链接形式
// import QrcodeVue from "qrcode.vue"
export default {
  data() {
    return {
      goodsObj: {
        goodsName: "",
        skuListStr: "",
        spuSn: "",
        qualityGuaranteePeriod: "",
        manufactureDate: "",
        costPrice: "",
        qrCodeBase64: ""
      }
    }
  },
  methods: {
    // 生成随机位数
    generateNumber(digits) {
      if (digits <= 0 || !Number.isInteger(digits)) {
        throw new Error("参数必须是正整数")
      }
    
      const min = Math.pow(10, digits - 1)
      const max = Math.pow(10, digits) - 1
    
      return Math.floor(Math.random() * (max - min + 1)) + min
    },
    async print(item) {
      const targte = JSON.parse(JSON.stringify(item))
      const qrCodeText = process.env.VUE_APP_WMS_H5 + "/#/inventory/out-detail/" + targte.outId + "?outNo=" + targte.outNo
      const qrCodeBase64 = await QRCode.toDataURL(qrCodeText)
      targte.qrCodeBase64 = qrCodeBase64
      this.goodsObj = targte

      setTimeout(() => {
        printJS({
          printable: "print-goods-tag-one",
          type: "html",
          targetStyles: ["*"],
          scanStyles: false,
          style: `
          .goods-tag-item {
            width: 60mm;
            height: 38mm;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            position: relative;
          }
          .goods-tag-item .goods-tag-left {
            flex-grow: 1;
          }
          .goods-tag-item .goods-tag-left .out-no {
            font-size: 8px;
          }
          .goods-tag-item .goods-tag-left .other {
            font-size: 8px;
            margin-top: 1mm;
          }
          .goods-tag-item .goods-tag-right {
            flex-shrink: 0;
            margin-right: 2mm;
          }
          .goods-tag-item .goods-tag-right .qr-code {
            width: 20mm;
            height: 20mm;
          }
          
          @media print {
            .goods-tag-container .goods-tag-item { 
              page-break-after: always;
            }
          }
        `
        })
      }, 0)
    }
  }
}
</script>
<style lang="scss" scoped>
.goods-tag-container {
  position: absolute;
  height: 0;
  overflow: hidden;

  .goods-tag-item {
    width: 60mm;
    height: 40mm;
    padding: 12px;
    margin: 0 auto;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: relative;

    .goods-tag-left {
      flex-grow: 1;

      .goods-name {
        font-weight: bold;
        font-size: 14px;
      }

      .sku-name,
      .date,
      .company-name {
        font-size: 12px;
        margin-top: 2mm;
      }
    }

    .goods-tag-right {
      flex-shrink: 0;

      .qr-code {
        width: 20mm;
        height: 20mm;
      }
    }
  }
}
</style>